import React, { useState } from 'react'
import styles from './MicrositeBuildLog.module.css'
import { ChevronDown, ChevronRight, Terminal } from 'lucide-react'

/**
 * MicrositeBuildLog
 * Collapsible build log viewer — collapsed by default, expands to
 * show the raw log text in a JetBrains Mono code block. Used on
 * MicrositePublish, primarily surfaced when buildStatus is FAILED.
 *
 * Usage:
 *   <MicrositeBuildLog log={buildStatus?.buildLog} defaultOpen={buildStatus?.buildStatus === 'FAILED'} />
 */
const MicrositeBuildLog = ({ log, defaultOpen = false }) => {
    const [open, setOpen] = useState(defaultOpen)

    if (!log) return null

    return (
        <div className={styles.wrap}>
            <button type="button" className={styles.toggle} onClick={() => setOpen((o) => !o)}>
                {open ? <ChevronDown size={14} /> : <ChevronRight size={14} />}
                <Terminal size={13} />
                Build log
            </button>

            {open && <pre className={styles.logBlock}>{log}</pre>}
        </div>
    )
}

export default MicrositeBuildLog